// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__z6yV-","checked":"Toggle_checked__E-mSE","input":"Toggle_input__LRa3x","dot":"Toggle_dot__IyiuV"};